<template>
    <div>
        <section class="home-section-2 home-section-small section-b-space">
                <div class="container-fluid-lg mb-4">
                    <div id="carouselExampleIndicators" class="carousel slide hero-slider" data-bs-ride="carousel" >
                        <ol class="carousel-indicators">
                            <template v-for="(item,index) in sliders?.data" >
                                <li data-bs-target="#carouselExampleIndicators" :data-bs-slide-to="index"  :class="{'active' : index == 0}"></li>
                            </template>
                        </ol>
                        <div class="carousel-inner">
                            <template v-for="(item,index) in sliders?.data" >
                                <div class="carousel-item  text-center " :class="{'active' : index == 0}">
                                    <div class="d-flex align-items-center">

                                        <img :src="item.image_pc"
                                             class="   d-none d-md-block" alt="">

                                        <img :src="item.image_mobile"
                                             class="   d-block d-md-none" alt="">

                                    </div>
                                </div>

                            </template>
                        </div>
                        <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </a>
                    </div>
                </div>
        </section>

<!--        <section class="category-section-2 mb-4">-->
<!--            <div class="alert alert-warning text-center">-->
<!--                {{ $t('Orders are currently within the Riyadh region only') }}-->
<!--            </div>-->
<!--        </section>-->

        <!-- Category Section Start -->
        <section class="category-section-2 mb-4">
            <div class="container-fluid-lg">
                <div class="title">
                    <h2>{{ $t('Gifts according to the product') }}</h2>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="category-slider-2 product-wrapper no-arrow" style="display: none">
                            <div v-for="occasion in main?.occasions">

                                <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'occasion_ids[]': occasion.id } }"
                                             @click="scrollToTop" class="category-box category-dark">
                                    <div>
                                        <img :src="occasion?.icon" class="blur-up lazyload" alt="">
                                        <h5>{{ occasion?.name}}</h5>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Category Section End -->

        <!-- Category Section Start -->
        <section class="category-section-2 mb-4">
            <div class="container-fluid-lg">
                <div class="title">
                    <h2>{{ $t('Gifts by category') }}</h2>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="category-slider arrow-slider"  style="display: none">
                            <div v-for="category in main?.categories">
                                <div class="shop-category-box border-0 wow fadeIn">
                                    <router-link :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'category_ids[]': category.id } }"
                                                 @click="scrollToTop" class="footer-contain-2">
                                        <img :src="category.icon" class="img-fluid blur-up lazyload"
                                             :alt="category.name">
                                        <div class="category-name">
                                            <h6>{{ category.name }}</h6>
                                        </div>
                                    </router-link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Category Section End -->

        <!-- Product Sction Start -->
        <section class="product-section mb-4">
            <div class="container-fluid-lg">
                <div class="title title-flex-2">
                    <h2>{{ $t('Most ordered gifts') }}</h2>
                </div>
                <div class="tab-content" id="myTabContent">

                    <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
                        <div class="row g-8 d-flex align-items-stretch">

                            <div class="d-flex  col-xxl-2 col-lg-3 col-md-4 col-6 wow fadeInUp" data-wow-delay="0.05s"
                                 v-for="product in most_ordered?.data">
                                <div class="product-box-4 w-100  d-flex flex-column">
                                    <div class="product-image cover-image">
                                        <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                            <img :src="product?.image  ?? '/theme/assets/images/more/gift-card.png'" class="img-fluid" alt="">
                                        </router-link>
                                    </div>

                                    <div class="product-detail text-start h-100 d-flex flex-column">

                                        <router-link :to="{name: 'products.show', params: { id: product.id  , lang : $i18n.locale  }}"
                                                     class="h-100">
                                            <h5 class="mb-3">{{ product.name }}</h5>
                                        </router-link>


                                        <h5 class="price theme-color" v-if="product.price">{{ product.price_tax }} {{ $t('SAR') }} </h5>

                                        <CartButton :product="product" :type="'small-icon'"></CartButton>
                                     </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="product-section mb-4">
            <div class="container-fluid-lg">
                <div class="title title-flex-2">
                    <h2>{{ $t('Gifts') }}</h2>
                </div>
                <div class="tab-content" id="myTabContent">

                    <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
                        <div class="row g-8 d-flex align-items-stretch">

                            <div class="d-flex  col-xxl-2 col-lg-3 col-md-4 col-6 wow fadeInUp" data-wow-delay="0.05s"
                                 v-for="product in products?.data">
                                <div class="product-box-4 w-100  d-flex flex-column">
                                    <div class="product-image cover-image">
                                        <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                            <img :src="product?.image  ?? '/theme/assets/images/more/gift-card.png'" class="img-fluid" alt="">
                                        </router-link>
                                    </div>

                                    <div class="product-detail text-start h-100 d-flex flex-column">

                                        <router-link :to="{name: 'products.show', params: { id: product.id  , lang : $i18n.locale  }}"
                                                     class="h-100">
                                            <h5 class="mb-3">{{ product.name }}</h5>
                                        </router-link>


                                        <h5 class="price theme-color" v-if="product.price">{{ product.price_tax }} {{ $t('SAR') }} </h5>

                                        <CartButton :product="product" :type="'small-icon'"></CartButton>
                                     </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Product Sction End -->
    </div>
</template>

<script>
import  CartButton from "../components/cart_item/CartButton.vue"
export default {
    components: {
        CartButton
    },
    name: "home",
    props: ['main'],
    watch: {
        main(newValue) {
            if (newValue !== null) {
                this.runSlider();
            }
        }
    },
    data() {
        return {
            sliders: [],
            products: [],
            most_ordered: [],
        }
    },
    async created() {
        // $('.category-slider-2').hide();
        // $('.category-slider').hide();
        await this.getSliders();
        await this.getProducts();
        await this.getMostOrderedProducts();
        this.runSlider();
    },
    methods:{
        scrollToTop() {
            window.scrollTo(0,0);
        },
        async getSliders(page = this.$route?.query?.page ?? 1) {

            await axios.get('sliders').then(response => {
                this.sliders = response.data;
            });
        },
        async getProducts(page = this.$route?.query?.page ?? 1) {

            await axios.get('products' , { params : { 'random' : true  } }).then(response => {
                this.products = response.data;
            });
        },
        async getMostOrderedProducts(page = this.$route?.query?.page ?? 1) {

            await axios.get('most_ordered').then(response => {
                this.most_ordered = response.data;
            });
        },
        runSlider() {
            let  _that = this;
                setTimeout(function () {

                    if(_that.main?.occasions?.length > 0 ){
                        $('.category-slider-2').slick({
                        arrows: true,
                        infinite: true,
                        slidesToShow: 7,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1745,
                            settings: {
                                slidesToShow: 6,
                                dots: true,
                                autoplay: true,
                                autoplaySpeed: 2500,
                            }
                        },
                            {
                                breakpoint: 1540,
                                settings: {
                                    slidesToShow: 5,
                                    dots: true,
                                    autoplay: true,
                                    autoplaySpeed: 2500,
                                }
                            },
                            {
                                breakpoint: 910,
                                settings: {
                                    slidesToShow: 4,
                                    dots: true,
                                    autoplay: true,
                                    autoplaySpeed: 2500,
                                }
                            },
                            {
                                breakpoint: 730,
                                settings: {
                                    slidesToShow: 3,
                                    dots: true,
                                    autoplay: true,
                                    autoplaySpeed: 2500,
                                }
                            },
                            {
                                breakpoint: 410,
                                settings: {
                                    slidesToShow: 2,
                                    dots: true,
                                    autoplay: true,
                                    autoplaySpeed: 2500,
                                }
                            },
                        ]
                    });
                    }
                    if(_that.main?.categories.length > 0 ){
                        $('.category-slider').slick({
                        arrows: true,
                        infinite: true,
                        slidesToShow: 8,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1745,
                            settings: {
                                slidesToShow: 7,
                            }
                        },
                            {
                                breakpoint: 1399,
                                settings: {
                                    slidesToShow: 6,
                                }
                            },
                            {
                                breakpoint: 1124,
                                settings: {
                                    slidesToShow: 5,
                                }
                            },
                            {
                                breakpoint: 900,
                                settings: {
                                    slidesToShow: 4,
                                }
                            },
                            {
                                breakpoint: 692,
                                settings: {
                                    slidesToShow: 3,
                                }
                            }, {
                                breakpoint: 482,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                        ]
                    });
                    }

                    $('.category-slider-2').show();
                    $('.category-slider').show();
                }, 350);
        },
    }
}
</script>

<style scoped>

</style>
